import { EmeshApiClient } from "@/typescript/api_client/emesh_api/client";
import { AxiosResponse } from "axios";
import { getBearerToken } from "@/typescript/lib/common/get_bearer_token";
import {
  GetStoresResponse,
  GetStoresErrorResponse
} from "@/typescript/api_client/emesh_api/stores/types";

const emeshApiClient: EmeshApiClient = new EmeshApiClient("/v1/stores");

export async function getStoresApi(
  storeId: string
): Promise<GetStoresResponse> {
  return await emeshApiClient
    .get({
      params: {
        store_id: storeId
      },
      headers: {
        Authorization: getBearerToken()
      }
    })
    .then((resp: AxiosResponse<GetStoresResponse>) => {
      return Promise.resolve(resp.data as GetStoresResponse);
    })
    .catch(e => {
      if (e.data) return Promise.reject(e.data as GetStoresErrorResponse);
      return Promise.reject(e);
    });
}
